import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

export const BackButton = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      className=" text-white hover:text-white  py-2 px-4  underline"
    >
      {" "}
      <FontAwesomeIcon
        icon={faArrowLeft}
        size="sm"
        className="text-white mr-1"
      />
      Back
    </button>
  );
};
